<template>
    <div>
        <encabezado></encabezado>
        <breadcrum :titulo='titulo' :texto='texto'></breadcrum>
        <buscador></buscador>
        <div class="module-info" style="padding-left:25%" v-if="hayDatosOrden">
            <estado></estado>
            <acciones></acciones>
            <operaciones></operaciones>
            <datosDispositivo></datosDispositivo>
            <datosCliente></datosCliente>
        </div>
        <pie></pie>
    </div>
</template>

<script>
    import encabezado from '@/components/newEncabezado'
    import breadcrum from '@/components/breadcrum'
    import buscador from '@/components/buscador'
    import estado from '@/components/consultas/estado'
    import acciones from '@/components/consultas/acciones'
    import operaciones from '@/components/consultas/operaciones'
    import datosCliente from '@/components/consultas/datosCliente'
    import datosDispositivo from '@/components/consultas/datosDispositivo'
    import pie from '@/components/newPie'

    export default {
        components: {
            encabezado,
            breadcrum,
            buscador,
            acciones,
            estado,
            datosCliente,
            datosDispositivo,
            operaciones,
            pie
        },

        data: () => ({
            name: 'index',
            texto: 'Si ya tienes una referencia de orden de reparación, puedes obtener datos sobre el estado de la reparación con el buscador',
            titulo: 'Buscador'
        }),
        computed: {
            hayDatosOrden() {
                if (typeof this.$bus.pConsulta.datosOrden !== 'undefined' && Object.keys(this.$bus.pConsulta.datosOrden).length !== 0)
                    return true
                else
                    return false
            }
        }
    }
</script>